import { useEffect, useState } from "react"

import { subWeeks } from "date-fns"
import { DateRange } from "react-day-picker"

/** "1week", "2weeks", "4weeks", "8weeks", "12weeks" or "custom"; a Select value, so a string. */
export type DatePreset = string

/** "custom" leaves the range where the last preset put it, for the calendar to start from. */
export function useDateRangePreset() {
  const [dateRange, setDateRange] = useState<DateRange | undefined>(() => {
    const end = new Date()
    const start = subWeeks(end, 1)
    return { from: start, to: end }
  })
  const [datePreset, setDatePreset] = useState<DatePreset>("1week")

  useEffect(() => {
    if (datePreset === "custom") return

    const today = new Date()
    let start: Date

    switch (datePreset) {
      case "1week":
        start = subWeeks(today, 1)
        break
      case "2weeks":
        start = subWeeks(today, 2)
        break
      case "4weeks":
        start = subWeeks(today, 4)
        break
      case "8weeks":
        start = subWeeks(today, 8)
        break
      case "12weeks":
        start = subWeeks(today, 12)
        break
      default:
        start = subWeeks(today, 1)
    }

    setDateRange({ from: start, to: today })
  }, [datePreset])

  return { dateRange, setDateRange, datePreset, setDatePreset }
}
